import Cookies from 'js-cookie';
import qs from 'query-string';

export function setHasOffersTransactionId() {
  const hasOffersTransactionId = qs.parse(window.location.search).has_offers_tid;
  const hasOffersAffiliateId = qs.parse(window.location.search).has_offers_aid;

  Cookies.set('has_offers_tid', hasOffersTransactionId, {expires: 60, path: '/'});
  Cookies.set('has_offers_aid', hasOffersAffiliateId, {expires: 60, path: '/'});
}
